
export const environment = {
  production: false,
  URL_WEB: 'https://qasitio.sorteoanahuac.mx',
  URL_API_LEGALES: 'https://qaserviciossitioapp.sorteoanahuac.mx',
  URL_MICROSITIO: 'https://qapago.sorteoanahuac.mx/',
  URL_API_MAGNO: 'https://qaserviciosapp.sorteoanahuac.mx',
  URL_MICROSITIO_ANIV: '',
  URL_API_ANIV: '',
  ts: 'TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA',
 
  //TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA==
  //GCSaTPT6rUlfbDAriV5i4kIoS0w0d3oCXAh6v
};